import React, { Suspense } from "react";
import { createRoot } from "react-dom/client";
import LoadingCover from "./components/LoadingCover";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

const App = React.lazy(() => import("./App"));

const container = document.getElementById("root");
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(
  // <React.StrictMode>
  <Suspense fallback={<LoadingCover show="true" />}>
    <App />
  </Suspense>,
  // </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
